import { Component, OnInit } from '@angular/core';
import { AsyncPipe, DatePipe } from '@angular/common';
import { NonNullableFormBuilder } from '@angular/forms';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { ReactiveFormsModule } from '@angular/forms';
import { MessageService } from 'primeng/api';
import { NgxAimAdminPrimengModule } from '../../../ngx-aim-admin.primeng.module';
import { TrueFalseText } from '../../../../../types';
import { Ffl } from '../../../../../models';
import { CountryStateService, HttpErrorService, UtilsService } from '../../../../../services';
import { NgxAimAdminFflService } from '../ngx-aim-admin-admin-ffl.service';

@Component({
  selector: 'ngx-aim-admin-edit-ffl',
  standalone: true,
  imports: [ReactiveFormsModule, NgxAimAdminPrimengModule, AsyncPipe],
  templateUrl: './ngx-aim-admin-edit-ffl.component.html',
  styleUrls: ['./ngx-aim-admin-edit-ffl.component.scss', '../../../admin.scss'],
  providers: [DatePipe]
})
export class NgxAimAdminEditFflComponent implements OnInit {
  dropDownOptions: TrueFalseText[] = ['True', 'False'];
  states$ = this.countryStateService.states$;

  form = this.fb.group({
    id: this.fb.control<number>(0),
    name: this.fb.control<string>(''),
    address1: this.fb.control<string>(''),
    address2: this.fb.control<string>(''),
    city: this.fb.control<string>(''),
    state: this.fb.control<string>(''),
    zip: this.fb.control<string>(''),
    phone: this.fb.control<string>(''),
    fflNumber: this.fb.control<string>(''),
    willAcceptAllTransfers: this.fb.control<TrueFalseText>('False'),
  });

  metaForm = this.fb.group({
    createDate: [{ value: '', disabled: true }],
    updateDate: [{ value: '', disabled: true }],
  });

  isLoading = false;
  isSaving = false;

  constructor(
    private entityService: NgxAimAdminFflService,
    private fb: NonNullableFormBuilder,
    private config: DynamicDialogConfig,
    private dialogRef: DynamicDialogRef,
    private messageService: MessageService,
    private httpErrorService: HttpErrorService,
    private utils: UtilsService,
    private countryStateService: CountryStateService,
    private datePipe: DatePipe,
  ) {}

  ngOnInit() {
    this.countryStateService.initStates();
    if (typeof this.config.data === 'number') {
      this.getEntity(this.config.data);
    }
  }

  getEntity(entityId: number) {
    this.isLoading = true;
    this.entityService.findOne(entityId).subscribe({
      next: (entity) => this.setFormData(entity),
      error: (err) => this.onError(err, 'Could not retrieve ffl')
    });
  }

  setFormData(entity: Ffl) {
    console.log(entity);
    this.isLoading = false;
    this.form.patchValue({
      ...entity,
      willAcceptAllTransfers: this.utils.convertBooleanToTrueFalseText(entity.willAcceptAllTransfers),
    });

    this.metaForm.patchValue({
      createDate: this.datePipe.transform(new Date(entity.createDate), 'short')!,
      updateDate: this.datePipe.transform(new Date(entity.updateDate), 'short')!,
    });
  }

  onSave() {
    this.isSaving = true;
    const dto: Partial<Ffl> = {
      ...this.form.value,
      willAcceptAllTransfers: this.utils.convertTrueFalseTextToBoolean(this.form.controls.willAcceptAllTransfers.value),
    }
    this.entityService.save(dto).subscribe({
      next: (entity) => this.onSuccess(entity),
      error: (err) => this.onError(err, 'Could not save ffl')
    });
  }

  onCancel() {
    this.dialogRef.close();
  }

  onError(err: any, message: string) {
    this.isSaving = false;
    this.isLoading = false;
    this.httpErrorService.onHttpError(err, message);
  }

  onSuccess(entity: Ffl) {
    this.setFormData(entity);
    this.isSaving = false;
    this.messageService.add({
      severity: 'success',
      summary: 'Ffl saved',
      key: 'app-toast'
    });
  }
}
